import DebugUANC from './version/debug';
import { AD_SERVERS, UANC_CONFIG_EVENT } from '../configs/constants';
import { setGlobalAdServices } from '../services/ad-services/ad-services';
import { getAdServersToProcess } from '../services/ad-services/ad-services.utils';
import { initPrebid } from '../services/prebid/prebid';
import { prepareKeywords } from '../services/config-service/config-service';
import { IConfig } from '../uanc.types';

/**
 * Moduł odpowiedzialny m.in. za inicjalizację adserwerów DFP/AO, ich usług i zarządzanie reklamiami.
 *
 * @returns {void}
 */
export default async (): Promise<void> => {
    const { config, UANC, state, event } = window.Inpl.Ad;
    UANC instanceof DebugUANC && UANC.log('Starting embedding AdServices...');

    (window.Inpl.Ad?.config as IConfig).keywords = prepareKeywords(config?.keywords || {});
    event?.custom(UANC_CONFIG_EVENT, config);

    UANC!.unresolvedServices.length = 0;
    window.Inpl.Ad.services = {
        ...window.Inpl.Ad.services,
        resolved: false,
    };

    if (!state?.isReloadUanc) setGlobalAdServices(); // dodanie globalnych funkcji window.Inpl.Ad używanych przez serwisy
    const adServersToProcess = getAdServersToProcess(); // ad serwery do załadowania
    if (adServersToProcess.length) {
        await initPrebid();
        adServersToProcess.forEach((adServer: AD_SERVERS) => {
            if (adServer === AD_SERVERS.DFP) {
                import(/* webpackChunkName: "embedding-DFP" */ '../services/ad-services/DFP/embedding-dfp').then((module) =>
                    module.default()
                );
            } else if (adServer === AD_SERVERS.ADOCEAN) {
                import(/* webpackChunkName: "embedding-AO" */ '../services/ad-services/ADOCEAN/embedding-adocean').then((module) =>
                    module.default()
                );
            }
        });

        // uruchomienie automatycznego odświeżania reklam na stronie
        if (config?.refreshAds && typeof config.refreshAds.enabled === 'boolean' && typeof config.refreshAds.interval === 'number') {
            const { enabled, interval } = config.refreshAds;
            window.Inpl.Ad.setRefreshAdsInterval?.(enabled, interval);
            window.Inpl.Ad.initAdsRefresh?.();
        }
    }
};
